import React, { useEffect, useState } from 'react';
import { fetchScormFiles, startContentExtraction } from '../../../apis/scormUpload';
import { useNavigate } from 'react-router-dom';
import PaginationControls from '../PaginationControls';
import ScormFile from './ScormFile';

const PAGE_SIZE = 5;

const ScormFilesList = () => {
    const [files, setFiles] = useState([]);
    const [totalCount, setTotalCount] = useState(0);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [page, setPage] = useState(1);
    const [extractingId, setExtractingId] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        setLoading(true);
        fetchScormFiles(page)
            .then((res) => {
                setFiles(res.data.results || []);
                setTotalCount(res.data.count || 0);
                setLoading(false);
            })
            .catch(() => {
                setError('Failed to load files');
                setLoading(false);
            });
    }, [page]);

    const handleStartExtraction = async (file) => {
        setExtractingId(file.id);
        setFiles((prev) => prev.map((f) => (f.id === file.id ? { ...f, status: 'content_extraction_in_progress' } : f)));
        try {
            const res = await startContentExtraction(file.id);
            const updatedFile = res.data.scorm_file;
            setFiles((prev) => prev.map((f) => (f.id === file.id ? updatedFile : f)));
        } catch (e) {
            setFiles((prev) => prev.map((f) => (f.id === file.id ? { ...f, status: 'extracted' } : f)));
        }
        setExtractingId(null);
    };

    // Pagination logic
    const totalPages = Math.ceil(totalCount / PAGE_SIZE);

    return (
        <div className="container py-1 mb-5 pb-5">
            <div className="card border-0 pb-5">
                <div className="card-body p-4">
                    <h3 className="mb-4 fw-semibold text-dark">Uploaded SCORM Files</h3>
                    {loading ? (
                        <div className="text-center py-5">
                            <div className="spinner-border text-primary" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    ) : error ? (
                        <div className="alert alert-danger text-center">{error}</div>
                    ) : files.length === 0 ? (
                        <div className="text-cent er text-muted py-5">No files found.</div>
                    ) : (
                        <>
                            <div className="list-group mb-4">
                                {files.map((file) => (
                                    <ScormFile
                                        key={file.id || file.file_name}
                                        file={file}
                                        extractingId={extractingId}
                                        handleStartExtraction={handleStartExtraction}
                                        navigate={navigate}
                                    />
                                ))}
                            </div>

                            {/* Pagination */}
                            <PaginationControls page={page} totalPages={totalPages} setPage={setPage} />
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ScormFilesList;
